<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M42.82 23.16L24.82 5.16C24.1 4.44 23.1 4 22 4H8C5.8 4 4 5.8 4 8V22C4 23.1 4.44 24.1 5.18 24.84L23.18 42.84C23.9 43.56 24.9 44 26 44C27.1 44 28.1 43.56 28.82 42.82L42.82 28.82C43.56 28.1 44 27.1 44 26C44 24.9 43.54 23.88 42.82 23.16ZM26 40.02L8 22V8H22V7.98L40 25.98L26 40.02Z"
            fill="currentColor" />
        <path
            d="M13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10C11.3431 10 10 11.3431 10 13C10 14.6569 11.3431 16 13 16Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
